import { getToken } from '@/utils/auth'

class WebSocketServer {
  constructor(url, callback, param) {
    this.websocket = null
    this.isConnect = false
    this.timeoutNum = null
    this.timeoutObj = null
    this.serverTimeoutObj = null
    this.timeout = 10000
    this.isActivelyClose = false
    this.url = url || process.env.VUE_APP_WEBSOCKET // 'ws://82.157.123.54:9010/ajaxchattest'//
    this.param = param
    this.callback = callback || null
  }

  connect(callback) {
    this.websocket = new WebSocket(
      this.url + '?S-Token=' + (getToken() && getToken().substring(1))
    )
    // this.websocket.onHeaders = headers => {
    //   headers.push('Set-Cookie: ""')
    // }
    this.initWebScoket(this.param)
  }

  initWebScoket(param) {
    this.isActivelyClose = false

    this.websocket.onopen = () => {
      // store.commit('SET_WEBSOCKET', true)
      // 开始websocket心跳
      this.startWsHeartbeat()
      this.isConnect = true
    }

    this.websocket.onmessage = msg => {
      // 服务端发送来的消息存到vuex
      // if (msg.data === 'success' || msg.data === '您未绑定席位或未设置绑定号码') return
      try {
        if (msg.data && JSON.parse(msg.data).msgType) {
          // store.commit('user/SET_WEBSOCKETMSG', msg.data)
          // console.log('接受消息:' + msg.data)
          this.callback && this.callback(JSON.parse(msg.data))
        }
      } catch (err) {
        // console.log(err)
      }
    }

    this.websocket.onclose = e => {
      // console.log('e', e)
      this.isConnect = false
      // 如果手动关闭则不进行重连
      // store.commit('SET_WEBSOCKET', false)
      // 如果手动关闭则不进行重连
      if (!this.isActivelyClose) {
        this.reconnectSocket(param)
      } else {
        clearTimeout(this.timeoutObj)
        clearTimeout(this.serverTimeoutObj)
        this.websocket = null
      }
    }

    this.websocket.onerror = e => {
      // console.log('e', e)
      // store.commit('SET_WEBSOCKET', false)
      if (!getToken()) {
        this.websocket.close()
        return null
      }
      this.reconnectSocket(param)
    }
  }

  /**
   * websocket连接状态下才能进行send
   * @param {*} msg
   * 向服务send的消息
   */
  send(msg) {
    if (this.websocket.readyState === 1) {
      this.websocket.send(msg)
    }
  }

  close() {
    this.isActivelyClose = true
    if (this.websocket) {
      this.websocket.close()
    }
  }

  reconnectSocket(param) {
    if (this.isConnect === true) {
      return false
    }
    // console.log('websocket 重新连接~ ')
    this.isConnect = true
    this.timeoutNum && clearTimeout(this.timeoutNum)
    this.timeoutNum = setTimeout(() => {
      this.connect(param)
      this.isConnect = false
    }, 2000)
  }

  //  开启心跳
  startWsHeartbeat() {
    const that = this
    this.timeoutObj && clearTimeout(this.timeoutObj)
    this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj)
    this.timeoutObj = setInterval(() => {
      that.send('123456789')
    }, this.timeout)
  }
}

export default WebSocketServer
